import rootReducer from "reducers";
import { configureStore } from "@reduxjs/toolkit";
import { billingAmountApi } from "app/store/billingAmount/api/billingAmountApi";

import { revenueAnalyticApi } from "app/store/dashboard/revenue_analytic/revenueAnalyticApi";
import { electronicDeviceApi } from "app/store/dashboard/electronic_device/electronicDeviceApi";
import { manufacturerListApi } from "app/store/dashboard/patient_analytic/api/manufacturerListApi";

import { doctorAnalyticApi } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import { patientAnalyticApi } from "app/store/dashboard/patient_analytic/api/patientAnalyticApi";
import { surgeryProcedureApi } from "app/store/dashboard/surgery_types_procedures/api/surgeryProcedureApi";

import { transmissionAnalyticApi } from "app/store/dashboard/transmission_analytic/api/transmissionAnalyticApi";
import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
import { transmissionNotesApi } from "app/store/transmission/api/transmissionNotesApi";
import { transmissionDetailApi } from "app/store/transmission/api/transmissionDetailApi";

import { devicesApi } from "app/store/devices/deviceApi";
import { insuranceApi } from "./insurance/api/insuranceApi";
import { patientApi } from "app/store/patient/api/patientApi";
import { resetPasswordApi } from "./auth/api/resetPasswordApi";
import { patientProfileDocumentApi } from "./patientProfile/documents/api/patientProfileDocumentApi";
import { letterTemplateApi } from "./letterTemplate/api/letterTemplateApi";

import { manufacturerApi } from "./manufacturers/api/manufacturersApi";
import { archiveReportApi } from "./archiveReport/api/archiveReportApi";
import { accountApi } from "app/store/account/api/accountApi";

import { accountPreferenceApi } from "./accountPreference/api/accountPreferenceApi";
import { patientProfileReportApi } from "./patientProfile/reports/api/patientProfileReportApi";
import { accountDocumentApi } from "./accountDocument/api/accountDocumentApi";
import { adtApi } from "./adt/api/adtApi";
import { notificationPreferenceApi } from "./notificationPreference/api/notificationPreferenceApi";
import { subscriptionLogApi } from "./patientProfile/tasks/subscription/subscriptionLogApi";
import { patientProfileTaskApi } from "./patientProfile/tasks/api/patientProfileTaskApi";
import { jobApi } from "./ehrJobs/api/jobApi";
import { tasksApi } from "./tasks/api/taskApi";
import { accountAnalyticApi } from "./dashboard/account_analytic/api/accountAnalyticApi";
import { patientComplianceAnalyticApi } from "./dashboard/patient_compliance_analytic/api/patientComplianceAnalyticApi";
import { hl7JobsApi } from "app/services/job/hl7Jobs";
import { referringProviderApi } from "app/store/referringProvider/api/referringProviderApi";
import { userApi } from "./user/api/userApi";
import { rpmApi } from "./rpm/api/rpmApi";
import { billableIntervalAnalyticApi } from "./dashboard/billable_interval_analytic/api/billableIntervalAnalyticApi";
import { userActivityLogApi } from "./userActivityLog/api/userActivityLogApi";
import { liveCallTasksApi } from "./liveCallTasks/api/liveCallTasksApi";
import { quickTextTemplateApi } from "./quickTextTemplates/api/quickTextTemplateApi";
import { alertProtocolApi } from "./alertProtocol/api/alertProtocolApi";
import { notificationApi } from "./notification/api/notificationApi";

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat([
      accountApi.middleware,
      accountPreferenceApi.middleware,
      patientAnalyticApi.middleware,
      doctorAnalyticApi.middleware,
      manufacturerListApi.middleware,
      electronicDeviceApi.middleware,
      transmissionAnalyticApi.middleware,
      surgeryProcedureApi.middleware,
      billingAmountApi.middleware,
      revenueAnalyticApi.middleware,
      accountAnalyticApi.middleware,
      patientComplianceAnalyticApi.middleware,
      transmissionTableApi.middleware,
      transmissionDetailApi.middleware,
      transmissionNotesApi.middleware,
      devicesApi.middleware,
      insuranceApi.middleware,
      patientApi.middleware,
      resetPasswordApi.middleware,
      patientProfileDocumentApi.middleware,
      letterTemplateApi.middleware,
      patientProfileReportApi.middleware,
      accountDocumentApi.middleware,
      subscriptionLogApi.middleware,
      manufacturerApi.middleware,
      archiveReportApi.middleware,
      adtApi.middleware,
      notificationPreferenceApi.middleware,
      patientProfileTaskApi.middleware,
      jobApi.middleware,
      tasksApi.middleware,
      hl7JobsApi.middleware,
      referringProviderApi.middleware,
      userApi.middleware,
      rpmApi.middleware,
      billableIntervalAnalyticApi.middleware,
      userActivityLogApi.middleware,
      liveCallTasksApi.middleware,
      quickTextTemplateApi.middleware,
      alertProtocolApi.middleware,
      notificationApi.middleware,
    ]),
});

export { store };
